import axios from "axios";

import { IGetPendingBookingsListParams, IMobilityStoreActivitiesByRegionList } from "../../pages/dashboard/types";

export const getMobilityStoresActivitiesByRegion = async (params: IGetPendingBookingsListParams): Promise<IMobilityStoreActivitiesByRegionList[]> => {
    const response = await axios.post('/booking/dashboard/byRegions', params);
    return response.data;
};
